import { EditIcon, Trash2Icon } from 'lucide-react';
import React, { useEffect, useState } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow
} from '../shadcn/ui/table';
import { Users } from '@/entities/users';

type UsersProps = {
  data: Users[];
  onUserDelete: (index: number) => void;
  setOpen: (value: boolean) => void;
  open: boolean;
  setSelectedUser: (data: any) => void;
  setEdit: (value: boolean) => void;
  setIdToEdit: (value: number) => void;
};

const UserTableView: React.FC<UsersProps> = ({
  data,
  onUserDelete,
  setOpen,
  setSelectedUser,
  setEdit,
  setIdToEdit,
}) => {
  return (
    <div className="m-4 rounded-md sm:border">
      <Table>
        <TableHeader >
          <TableRow className= 'bg-indigo-50 mx-2'>
            <TableHead>Nome</TableHead>
            <TableHead>Email</TableHead>
            <TableHead>Empresa</TableHead>
            <TableHead>Ações</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {data.map((user, index) => (
            <TableRow className='mx-2' key={index}>
              <TableCell>{user.name}</TableCell>
              <TableCell>{user.email}</TableCell>
              <TableCell>{user.company.fantasyName}</TableCell>
              <TableCell>
                <div className="flex gap-2">
                  <button title="Apagar">
                    <Trash2Icon
                      onClick={() => {
                        onUserDelete(index);
                        // deleteUser(user.id); <- você pode habilitar isso se necessário
                      }}
                      size={26}
                      className="bg-red-600 hover:bg-red-800 rounded-md p-1"
                    />
                  </button>
                  <button
                    title="Editar"
                    onClick={() => {
                      setOpen(true);
                      setSelectedUser(user);
                      setEdit(true);
                      setIdToEdit(user.userId);
                    }}
                  >
                    <EditIcon
                      size={26}
                      className="bg-lime-600 hover:bg-lime-800 rounded-md p-1"
                    />
                  </button>
                </div>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};

export default UserTableView;
